import React from 'react';
import { theme } from '../../../../shared/lib/styles';

const MultipleChoiceQuestion = ({ question, onAnswer, answered, selectedIndex }) => {
    const handleSelect = (index) => {
        if (answered) return;
        onAnswer(index === question.correctIndex, index);
    };

    return (
        <div style={styles.options}>
            {question.options.map((opt, i) => {
                let bg = theme.colors.parchmentPaper;
                let border = theme.colors.borderMedium;
                if (answered) {
                    if (i === question.correctIndex) {
                        bg = 'rgba(200, 220, 190, 0.7)';
                        border = theme.colors.success;
                    } else if (i === selectedIndex) {
                        bg = theme.colors.errorBg;
                        border = theme.colors.danger;
                    }
                }
                return (
                    <button
                        key={opt}
                        type="button"
                        disabled={answered}
                        onClick={() => handleSelect(i)}
                        style={{
                            ...styles.optionBtn,
                            backgroundColor: bg,
                            borderColor: border,
                        }}
                    >
                        {opt}
                    </button>
                );
            })}
        </div>
    );
};

const styles = {
    options: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.md,
    },
    optionBtn: {
        padding: theme.spacing.lg,
        fontSize: theme.fontSize.lg,
        borderRadius: theme.borderRadius.lg,
        border: '2px solid',
        cursor: 'pointer',
        textAlign: 'left',
        fontWeight: theme.fontWeight.medium,
    },
};

export default MultipleChoiceQuestion;
